import "./Login.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faEye,
    faEyeSlash,
    faSignInAlt,
} from "@fortawesome/free-solid-svg-icons";
import {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import {Loader} from "../../utils/Loader";
import Cookies from "js-cookie";
import {GoogleLogin} from '@react-oauth/google';
import {jwtDecode} from "jwt-decode";
import {fetchUserByEmail} from "../../utils/GoogleSignIn/GoogleSignInAndUp";

function Login() {
    const [inputType, setInputType] = useState("password");
    const [password, setPassword] = useState("");
    const [email, setemail] = useState("");
    const [isBtnCliquer, setBtnCliquer] = useState(false);
    const [isDataLoading, setDataLoading] = useState(false);
    const [mdpOublie, setMdpOublie] = useState(false);
    const navigate = useNavigate();

    const setCookie = (token) => {
        Cookies.set("auth_token", token, {expires: 7});
    };

    const togglePasswordVisibility = () => {
        setInputType(inputType === "password" ? "text" : "password");
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            setBtnCliquer(true);
        }
    };

    const getTokenAuthentification = async () => {
        const user = {
            email: email,
            password: password,
        };
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(user),
            });

            if (response.ok) {
                const data = await response.json();
                setCookie(data.token);
                return data;
            } else {
                console.error("Client non trouvé");
            }
        } catch (error) {
            console.error("Erreur de connexion au serveur:", error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (isBtnCliquer) {
                try {
                    setDataLoading(true);
                    const data = await getTokenAuthentification();
                    if (data) {
                        const userData = data.user;
                        const userName = `${userData.prenom}`;
                        Cookies.set("name", userName, {expires: 7});
                        if (userData.id === process.env.REACT_APP_ADMIN_ID) {
                            Cookies.set("role", "admin", {expires: 7});
                            navigate("/admin")
                        } else {
                            navigate("/profil/infos-persos", {
                                state: {
                                    nom: userData.nom,
                                    prenom: userData.prenom,
                                    adresseEmail: userData.adresseEmail,
                                    numeroTel: userData.numeroTel,
                                    civilite: userData.civilite
                                },
                            });
                        }
                    } else {
                        Swal.fire({
                            text: "Compte non trouvé avec cette combinaison email/mot de passe",
                            icon: "error",
                            confirmButtonText: "Ok",
                        });
                        setBtnCliquer(false);
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    setDataLoading(false);
                }
            }
        };
        fetchData();
    }, [isBtnCliquer]);

    useEffect(() => {
        if (mdpOublie) {
            handleForgotPassword();
        }
        setMdpOublie(false);
    }, [mdpOublie]);

    const handleForgotPassword = async () => {
        const {value: email} = await Swal.fire({
            title: "Récupération du mot de passe",
            text: "Renseignez l'adresse email associé à votre compte.",
            input: "email",
            inputPlaceholder: "Entrer l'adresse email",
            showCancelButton: true,
            confirmButtonText: "Envoyer",
            cancelButtonText: "Annuler",
        });

        if (email) {
            try {
                setDataLoading(true);
                const response = await fetch(`${process.env.REACT_APP_API_URL}auth/forgot-password`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({email: email}),
                });

                if (response.ok) {
                    Swal.fire({
                        title: "Email envoyé",
                        text: "Un email de réinitialisation de mot de passe a été envoyé.",
                        icon: "success",
                        confirmButtonText: "Ok",
                    });
                } else if (response.status === 409) {
                    Swal.fire({
                        title: "Compte non activé",
                        text: "Vérifiez vos emails pour activer votre compte.",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                } else if (response.status === 408) {
                    Swal.fire({
                        title: "Action impossible",
                        text: "Vous vous êtes inscrit via Google, veuillez vous connecter via Google.",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                } else {
                    Swal.fire({
                        title: "Erreur",
                        text: "Une erreur s'est produite lors de l'envoi de l'email.",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                }
            } catch (error) {
                console.error(error);
            } finally {
                setDataLoading(false);
            }
        }
    };

    return (
        <div className="auth-page-container">
            {isDataLoading ? (
                <Loader/>
            ) : (
                <div className="auth-card">
                    <div className="auth-form-section">
                        <h2>Content de vous revoir</h2>
                        
                        <div className="form-group">
                            <label>Email</label>
                            <div className="input-wrapper">
                                <input
                                    className="input-login"
                                    placeholder="votre@email.com"
                                    value={email}
                                    onChange={(e) => setemail(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Mot de passe</label>
                            <div className="input-wrapper">
                                <input
                                    className="input-login"
                                    type={inputType}
                                    value={password}
                                    placeholder="••••••••"
                                    onChange={(e) => setPassword(e.target.value)}
                                    onKeyUp={handleKeyPress}
                                />
                                <FontAwesomeIcon 
                                    icon={inputType === "password" ? faEye : faEyeSlash} 
                                    id="icon-eye-see-password"
                                    onClick={togglePasswordVisibility}
                                />
                            </div>
                        </div>

                        <div className="forgot-password-link" onClick={() => setMdpOublie(true)}>
                            Mot de passe oublié ?
                        </div>

                        <button
                            className="btn-login"
                            onClick={() => setBtnCliquer(true)}
                        >
                            Se connecter
                            <FontAwesomeIcon icon={faSignInAlt} className="icon-signIn"/>
                        </button>

                        <div className="divider">
                            <span>Ou continuer avec</span>
                        </div>

                        <div className="google-login-container">
                            <GoogleLogin
                                onSuccess={credentialResponse => {
                                    const decodedToken = jwtDecode(credentialResponse?.credential);
                                    fetchUserByEmail(decodedToken, navigate, credentialResponse?.credential);
                                }}
                                onError={() => {
                                    console.log('Login Failed');
                                }}
                            />
                        </div>

                        <div className="auth-switch">
                            <span>Première visite ?</span>
                            <span className="bold-text" onClick={() => navigate("/auth/register")}>
                                Inscrivez-vous
                            </span>
                        </div>
                    </div>
                    
                    <div className="auth-image-section">
                        <img
                            src="https://res.cloudinary.com/dc1p20eb2/image/upload/v1709209172/Page%20Login/sebastien.png"
                            alt="image décoration connexion"
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Login;
